import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useWorkspace } from '../../contexts/WorkspaceContext';
import { hasCapability, type Capability } from '../../permissions';

interface RequireCapabilityProps {
  capability: Capability;
  realRoleOnly?: boolean;
  fallback?: React.ReactNode;
  children: React.ReactNode;
}

export const RequireCapability: React.FC<RequireCapabilityProps> = ({
  capability,
  realRoleOnly = false,
  fallback,
  children,
}) => {
  const { user, isLoading } = useAuth();
  const { workspace } = useWorkspace();

  const targetForCheck = workspace?.userRole
    ? { role: workspace.userRole }
    : user?.role
      ? { role: user.role }
      : null;
  const hasCapabilityForUser = hasCapability(targetForCheck, capability, { realRoleOnly });

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen text-sm text-slate-500">
        Carregando permissões...
      </div>
    );
  }

  if (!hasCapabilityForUser) {
    return fallback ?? <Navigate to="/minha-mesa" replace />;
  }

  return <>{children}</>;
};
